$(document).ready(function () {
  $('div[data-warranty-link]').on('click tap', function (e) {
    e.preventDefault();
    window.location.href = $(this).data('warranty-link');
  });


  //WARRANTY FILE
  function clearFileInput() {
    var input = document.createElement("input");
    input.setAttribute('type', 'file');
    input.setAttribute('value', '');
    input.setAttribute('id', 'warranty_file');

    $('#warranty_file').replaceWith( input.cloneNode() );
  }

  $('#remove_file').on('click tap', function (e) {
    e.preventDefault();
    clearFileInput();
    $('#warranty_select_file').show();
    $('#file_name').hide();
    $('#warranty_file_name').html('');
  });

  $('#warranty_select_file').on('click tap', function (e) {
    e.preventDefault();
    $('#warranty_file').click();
    $('#warranty_file').change(function(e){
      var fileName = e.target.files[0].name;
      $('#warranty_select_file').hide();
      $('#file_name').show();
      $('#warranty_file_name').html(fileName);
    });
  });


  //WARRANTY FOLDER
  var showFolderName = function (e) {
    var val = $('#select-folder').val();
    var checked = $('#add-folder input:checked+label').length > 0;
    if (val === '' && checked) {
      $('#folder-name-section').show();
    } else {
      $('#folder-name-section').hide();
    }
  }

  $('#select-folder').change(showFolderName);

  $('#add-folder-checkbox').change(function (e) {
    var checked = $('#add-folder input:checked+label').length > 0;
    if (checked) {
      $('#select-folder-section').show();
      showFolderName();
    } else {
      $('#select-folder-section').hide();
      showFolderName();
    }
  });


  //CLAIM FILE
  function clearFileInputClaim() {
    var input = document.createElement("input");
    input.setAttribute('type', 'file');
    input.setAttribute('value', '');
    input.setAttribute('id', 'claim_file');

    $('#claim_file').replaceWith( input.cloneNode() );
  }

  function removeTableRow(id) {
    var tbody = document.getElementById('file-list');
    tbody.removeChild(tbody.childNodes[id-1]);
  }

  function createTableRow(id) {
    var tbody = document.getElementById('file-list');
    
    var a = document.createElement('a');
    var i = document.createElement('i');
    var tr = document.createElement('tr');
    var td_1 = document.createElement('td');
    var td_2 = document.createElement('td');
    var td_3 = document.createElement('td');
    var span_1 = document.createElement('span');
    var span_2 = document.createElement('span');
    var div = document.createElement('div');

    span_1.setAttribute('id', 'claim_file_name_'+id);
    td_1.appendChild(span_1);

    span_2.setAttribute('id', 'claim_status_'+id);
    div.setAttribute('id', 'file_loader_'+id);
    div.setAttribute('class', 'loader');
    td_2.appendChild(div);
    td_2.appendChild(span_2);

    i.setAttribute('class', 'fa fa-times');
    i.setAttribute('aria-hidden', 'true');
    a.setAttribute('class', 'remove_file_claim');
    a.setAttribute('id', 'claim_file_remove_'+id);
    a.appendChild(i);
    td_3.appendChild(a);

    tr.setAttribute('id','claim_file_'+id);
    tr.appendChild(td_1);
    tr.appendChild(td_2);
    tr.appendChild(td_3);
    tbody.appendChild(tr);

    a.onclick = function () {
      var file_count = $('#file-list')[0].childElementCount;
      if(file_count == 1) clearTableRow(id);
      else tbody.removeChild(tr);
    };
  }

  function clearTableRow(id){
    $('#file_loader_'+id).hide();
    $('#claim_file_remove_'+id).hide();
    $('#claim_file_name_'+id).html('-');
    $('#claim_status_'+id).html('-');
  }


  $('#claim_select_file').on('click tap', function (e) {
    e.preventDefault();
    var file_count = $('#file-list')[0].childElementCount;

    $('#claim_file').click();
    $('#claim_file').change(function(e){
      var fileName = e.target.files[0].name;
      var claim_file_name = "";
      var file_id = $('#file-list')[0].lastElementChild.id;
      file_id = file_id.toString().replace("claim_file_", "");
      
      if(file_count == 1){
        claim_file_name = $('#claim_file_name_'+file_id).text();
      }
      if(claim_file_name != '-'){
        file_id = parseInt(file_id)+1;
        createTableRow(file_id, file_count);
      }
      $('#file_loader_'+file_id).show();
      $('#claim_file_remove_'+file_id).show();
      $('#claim_file_name_'+file_id).html(fileName);
      $('#claim_status_'+file_id).html('');

      $('#file_loader_'+file_id).delay(800).fadeOut(800);
      $('#claim_status_'+file_id).slideUp(600).delay(1000).fadeIn(400);
      $('#claim_status_'+file_id).html('Uploaded');
      
      clearFileInputClaim();
    });
  });


  var toggleLabels = function () {
    if ($(this).is(':visible')) $(this).hide();
    else $(this).show();
  };

  var toggleInputs = function (selector, i) {
    if ($(this).is(':visible')) {
      var text = $(this).val();
      $($(selector + ' .details')[i + 1]).html(text);
      $(this).hide();
    } else {
      $(this).show();
      var text = $($(selector + ' .details')[i + 1]).text();
      text = _.isEmpty(text) ? '' : text.trim();
      $(this).val(text);
    }
  };

  var toggleTextArea = function (selector, i) {
    if ($(this).is(':visible')) {
      var text = $(this).text();
      $($(selector + ' .details')[i]).html(text);
      $(this).hide();
    } else {
      $(this).show();
      var text = $($(selector + ' .details')[i]).text();
      text = _.isEmpty(text) ? '' : text.trim();
      $(this).text(text);
    }
  };

  $('.item a[data-detail]').on('click tap', function (e) {
    e.preventDefault();

    var selector = '#' + $(this).data('detail');
    $(selector + ' textarea').each(function (i) {
      var bound = toggleTextArea.bind(this);
      bound(selector, i);
    });
    $(selector + ' input').each(function (i) {
      var bound = toggleInputs.bind(this);
      bound(selector, i);
    });
    $(selector + ' .details').each(toggleLabels);
  });

  var toggleDetail = function (selector, that) {
    var icon = $(that).find('i:first-child');
    if ($(selector).is(':visible')) {
      $(icon).attr('class', 'fa fa-caret-right');
      $(selector).slideUp('slow');
    } else {
      $(icon).attr('class', 'fa fa-caret-down');
      $(selector).slideDown('slow');
    }
  };

  $('a[data-detail]').on('click tap', function () {
    var selector = $(this).data('detail');
    toggleDetail(selector, this);
  });

  $('.open-warranty-claims').on('click tap', function () {
    $('[data-tabs-target="my-warranty"]').click();
  });

  $('.folder-click').on('click tap', function () {
    $('#tab-folder1').hide();
    $('#tab-folder2').show();
  });
  $('#folder-click-back').on('click tap', function () {
    $('#tab-folder2').hide();
    $('#tab-folder1').show();
  });

  $('#upload_document').on('click tap', function () {
    var file_count = $('#file-list')[0].childElementCount;
    if(file_count == 0){
      createTableRow(1);
      clearTableRow(1);
    }
  });
  
  $('#create-warranty-label').on('click tap', function () {
    if ($('#create-warranty').is(':visible')) {
      $('#create-new-warranty-section').animate({
        'padding-right' : '35%',
        'padding-left' : '35%',
      }, "slow");
    }
    else{
      $('#create-new-warranty-section').animate({
        'padding-right' : '0',
        'padding-left' : '0',
      }, "slow");
    }
    $('#create-warranty-label').blur();
  });

  $('#case-service-times').on('click tap', function () {
    var isOnclick = $('#case-service-times-load').hasClass("enabled");

    if(!isOnclick){
      $('#case-service-times-load').addClass("enabled");
      var checkbox = $('#case-service-times').find($("input"));

      for(i=0; i<checkbox.length; i++){
        checkbox[i].onchange = function(e){
          var i, checked = 0;
          var checkbox = $('#case-service-times').find($("input"));

          for(i=0; i<checkbox.length; i++){
            if(checkbox[i].checked) checked++;
          }
          if(checked == 0){
            for(i=0; i<checkbox.length; i++){
              checkbox[i].className = "is-invalid-input";
            }
            $('#case-service-times-error').show();
          }
          else{
            for(i=0; i<checkbox.length; i++){
              checkbox[i].className = "";
            }
            $('#case-service-times-error').hide();
          }
        }
      }
    }
  });

  $('#warranty-submit-button').on('click tap', function () {
    var warrantyModal = $('#warranty-submit-modal');
    var requestType = $('#case-request-type');
    var requestTypeSelect = requestType.find($('select'));
    var requestTypeSelectValue = requestType.find('.select2-selection__rendered')[0].textContent;
    var requestTypeError= requestType.find($('div'))[0];

    var caseContent = $('#warranty-case-content');
    var caseBoxes = caseContent.find($('.case-desc'));
    var caseTimeError = $('#case-service-times-error');
    var i, textArea, textAreaError;
    var error = false;

    if(requestTypeSelectValue.includes("*")){
      requestTypeSelect.addClass('is-invalid-input');
      $(requestTypeError).addClass("is-visible");
      error = true;
    }

    if(caseTimeError.is(":visible")){
      error = true;
    }

    for(i=0; i<caseBoxes.length; i++){
      textArea = caseBoxes[i].getElementsByTagName('textarea')[0];
      if(textArea.textLength == 0){
        textAreaError = $(textArea).parent().find($('div'))[0];
        $(textArea).addClass('is-invalid-input');
        $(textAreaError).addClass('is-visible');
        error = true;
      }
    }
    
    if(error){
      $('#warranty-submit-error').show();
    }
    else{
      $('#warranty-submit-error').hide();
      warrantyModal.removeAttr("data-mode");
      warrantyModal.attr("data-mode","submit");
      warrantyModal.click();
    }

    
  });

});